import React from 'react';

const ViewPlusIcon = (): React.ReactElement => (
    <svg
        className="device-svg-icons"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 24C0 16.5442 6.04416 10.5 13.5 10.5H34.5C41.9558 10.5 48 16.5442 48 24C48 31.4558 41.9558 37.5 34.5 37.5H13.5C6.04416 37.5 0 31.4558 0 24ZM13.5 13.5C7.70101 13.5 3 18.201 3 24C3 29.799 7.70101 34.5 13.5 34.5H34.5C40.299 34.5 45 29.799 45 24C45 18.201 40.299 13.5 34.5 13.5H13.5Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 24C15 21.1005 17.3505 18.75 20.25 18.75H27.75C30.6495 18.75 33 21.1005 33 24C33 26.8995 30.6495 29.25 27.75 29.25H20.25C17.3505 29.25 15 26.8995 15 24ZM20.25 21.75C19.0074 21.75 18 22.7574 18 24C18 25.2426 19.0074 26.25 20.25 26.25H27.75C28.9926 26.25 30 25.2426 30 24C30 22.7574 28.9926 21.75 27.75 21.75H20.25Z"
        />
    </svg>
);

export default ViewPlusIcon;
